import { LessonContentUpdateRequestTranslation } from "../../../api/lessons-update-content.generated";

type ScaleFormValues = {
  lessonContentType: string;
  nameEN: string;
  nameDE: string;
  textEN: string;
  textDE: string;
  notePlaceholder?: string;
  scaleContent?: string;
  scaleMinValue?: string;
  scaleMinLabelDE?: string;
  scaleMinLabelEN?: string;
  scaleMaxValue?: string;
  scaleMaxLabelDE?: string;
  scaleMaxLabelEN?: string;
};

export const parseMetaData = <T>(
  data: string | T | undefined | null
): T | null => {
  if (!data) return null;
  try {
    return typeof data === "string" ? JSON.parse(data) : data;
  } catch {
    return null;
  }
};

export const buildTranslations = (
  values: ScaleFormValues
): [
  LessonContentUpdateRequestTranslation,
  LessonContentUpdateRequestTranslation
] => {
  const enTranslation: LessonContentUpdateRequestTranslation = {
    language: "en",
    name: values.nameEN,
    text: values.textEN,
  };

  const deTranslation: LessonContentUpdateRequestTranslation = {
    language: "de",
    name: values.nameDE,
    text: values.textDE,
  };

  if (values.lessonContentType === "lct-reminder" && values.notePlaceholder) {
    const noteMetaData = { placeholder: values.notePlaceholder };
    enTranslation.noteMetaData = noteMetaData;
    deTranslation.noteMetaData = noteMetaData;
  }

  if (values.lessonContentType === "lct-scale") {
    const baseScaleData = {
      content: values.scaleContent || "",
      minValue: parseFloat(values.scaleMinValue || "0"),
      maxValue: parseFloat(values.scaleMaxValue || "0"),
    };

    enTranslation.scaleMetaData = {
      ...baseScaleData,
      minLabel: values.scaleMinLabelEN || "",
      maxLabel: values.scaleMaxLabelEN || "",
    };

    deTranslation.scaleMetaData = {
      ...baseScaleData,
      minLabel: values.scaleMinLabelDE || "",
      maxLabel: values.scaleMaxLabelDE || "",
    };
  }

  return [enTranslation, deTranslation];
};
